import React, { useState, useRef, useEffect } from "react";
import prolegionlogo from "../../Assets/ProLegionLogo.svg";
import { useSelector } from "react-redux";
import { Button, Popover } from "antd";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ProfileDropdown from "../../Components/ProfileDropdown";
import AccountProfileMenu from "../../Components/AccountProfileMenu";
import Badge from "@mui/material/Badge";
import { PublicUserInfo } from "../Auth/Helper";

const Header = ({
  role,
  setNotificationVisible,
  notificationVisible,
  notificationCount,
}) => {
  const [menuState, setMenuState] = useState(false);
  const [reload, setReload] = useState(false);
  const userId = localStorage.getItem("userId");
  const [user, setUser] = useState({});
  useEffect(() => {
    PublicUserInfo({ userId: userId })
      .then((res) => {
        setUser({
          ...res.data.result,
          name: `${res.data.result?.firstName ?? ""} ${res.data.result?.lastName ?? ""
            }`.trim(),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [reload]);
  const handleOnClick = () => {
    setMenuState(!menuState);
  };
  return (
    // <div
    //   className={`font-[Roboto] top-0 left-0 sticky z-5000 bg-red-500`}
    // >
    <div className="flex flex-row opacity-100 justify-between px-2 sm:px-8 h-24 items-center font-[Roboto] top-0 left-0 sticky z-[2147483647] w-[100%] bg-white" style={{ overflowX: 'hidden', overflowY: 'hidden', overscrollBehavior: "contain" }}>
      <div>
        <img
          alt="prolegionlogo"
          className=" w-[169px] h-[100px]"
          src={prolegionlogo}
        />
      </div>
      <div className="flex flex-row sm:space-x-8 space-x-2 items-center">
        <div></div>
        <Badge color="error" badgeContent={notificationCount}>
          <NotificationsIcon
            className="cursor-pointer"
            color="primary"
            fontSize="large"
            onClick={(e) => setNotificationVisible(!notificationVisible)}
          />
        </Badge>
        {/* <Popover placement="bottomRight" title={"TEXTETXTEXT"} trigger="click"> */}
        <Button
          className=" h-16 border-0 rounded-full"
          onClick={(e) => handleOnClick()}
        >
          <ProfileDropdown userType={role} />
        </Button>
        <AccountProfileMenu
          user={user}
          menuState={menuState}
          setMenuState={setMenuState}
          setReload={setReload}
        />
        {/* </Popover> */}
      </div>
    </div>
    // </div>
  );
};

export default Header;
